import React from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';
import { FormattedNumber } from '../../../FormattedNumber/FormattedNumber';

import { CustomFormInput } from '../../../../utils/FormFields';
import TransactionAccounts from './Accounts';

const Transaction = ({ transaction }) => {
  const transactionAmount = parseInt(transaction.TransactionCurrencyId, 10) > 0;
  return (
    <React.Fragment>
      <Row>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Type">
            {transaction.TransactionType}
          </CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Concept">
            {transaction.ConceptName}
          </CustomFormInput>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <CustomFormInput label="Settlement Date">
            <FormattedDate value={`${transaction.TransactionSettlementDate}T00:00`} />
          </CustomFormInput>
        </Col>
        {transactionAmount && (
          <Col xs={6} md={4} lg={3}>
            <CustomFormInput label="Amount">
              <FormattedNumber
                value={transaction.TransactionAmount}
                dataTypeDecimalName="currency"
              />
              {' '}
              {transaction.TransactionCurrencyIso}
            </CustomFormInput>
          </Col>
        )}
      </Row>
      <hr />
      <TransactionAccounts accounts={transaction.Account} showCurrency={!transactionAmount} />
    </React.Fragment>
  );
};

Transaction.propTypes = {
  transaction: PropTypes.object.isRequired,
};

export default Transaction;
